import React from "react";
import { Container, Row, Col, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useLocation } from "react-router-dom";

const ApplicationConfirmation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const applicationId = location.state?.applicationId;
  const ownerEmail = location.state?.ownerEmail;
  const ownerName = location.state?.ownerName || "Valued Customer";

  const handleNewApplication = () => {
    navigate("/external/application");
  };

  return (
    <Container className="mt-5" fluid>
      <Row className="justify-content-center">
        <Col lg="8" xl="6">
          <Card className="shadow">
            <CardBody className="text-center py-5">
              <div className="mb-4">
                <i
                  className="ni ni-check-bold text-success"
                  style={{ fontSize: "4rem" }}
                />
              </div>

              <h2 className="text-success mb-3">
                Application Submitted Successfully!
              </h2>

              <p className="text-muted mb-1" style={{ fontSize: "1.1rem" }}>
                Thank you for submitting your credit application. We have
                received your information and will review it shortly.
              </p>

              {applicationId && (
                <div className="mb-4">
                  <div
                    className="p-4 rounded-lg shadow-sm bg-white text-center"
                    style={{ maxWidth: "400px", margin: "0 auto" }}
                  >
                    <div className="d-flex justify-content-center mb-3">
                      <div
                        className="d-flex align-items-center justify-content-center rounded-circle bg-primary text-white"
                        style={{ width: "50px", height: "50px" }}
                      >
                        <i
                          className="ni ni-email-83"
                          style={{ fontSize: "1.5rem" }}
                        />
                      </div>
                    </div>
                    <h6 className="mb-2 text-dark font-weight-bold">
                      Confirmation Email Sent
                    </h6>
                    <p className="mb-2 text-muted">
                      Application ID:{" "}
                      <span className="font-weight-bold text-primary">
                        {applicationId}
                      </span>
                    </p>
                    <small className="text-muted">
                      A confirmation email has been sent to{" "}
                      <strong>{ownerEmail}</strong>. Please check your inbox for
                      further details.
                    </small>
                  </div>
                </div>
              )}

              <div className="d-flex justify-content-center">
                <Button
                  color="primary"
                  size="lg"
                  onClick={handleNewApplication}
                  className="px-4"
                >
                  <i className="ni ni-fat-add mr-2" />
                  Submit Another Application
                </Button>
              </div>

              <div className="mt-4 pt-4 border-top">
                <p className="text-muted small mb-0">
                  Need assistance? Contact us at{" "}
                  <a href="mailto:support@nlf.com" className="text-primary">
                    support@nlf.com
                  </a>{" "}
                  or call{" "}
                  <a href="tel:+1-800-NLF-HELP" className="text-primary">
                    1-800-NLF-HELP
                  </a>
                </p>
              </div>
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ApplicationConfirmation;
